import MenuItemContainer from "../../../containers/menu-item";
import {FormattedMessage} from "react-intl";
import MenuBarMenu from "../../../components/menu-bar/menu-bar-menu";
import React, {useState} from 'react';
import {connect} from 'react-redux';
import classNames from "classnames";
import styles from "../../../components/menu-bar/menu-bar.css";
import myStyles from "./dropdown-menu.css";
import Message from "../message/message";

const DropdownMenu = ({onOpen, title, items, onSelect, isRtl, type = "normal"}) => {
    const [isOpen, setOpen] = useState(false);

    return (
        <div>
            <div
                className={classNames(
                    styles.menuBarItem,
                    styles.hoverable
                )}
                onMouseUp={() => {
                    setOpen(!isOpen);
                    if (onOpen && !isOpen) onOpen();
                }}
            >
                {title}
            </div>
            <MenuBarMenu
                className={myStyles.menu}
                open={isOpen}
                // note: the Rtl styles are switched here, because this menu is justified
                // opposite all the others
                place={isRtl ? 'right' : 'left'}
                onRequestClose={() => {setOpen(false)}}
            >
                {items.map((item, index) => (
                    <MenuItemContainer key={item.id} className={item.available ? myStyles.itemAvailable : myStyles.itemNotAvailable} onClick={() => {
                        if (item.available) {
                            setOpen(false);
                            onSelect(item, index);
                        } else {
                            Message.show(window.L('teach.menu.itemNotAvailable'));
                        }
                    }}>
                        {
                            item.active ? (
                                <span style={{display: 'inline-block', width: 0, height: 0, borderTop: '5px solid transparent', borderLeft: '8px solid #fff', borderBottom: '5px solid transparent', paddingRight: '5px'}}></span>
                            ) : (null)
                        }
                        {
                            type === "member" ? (
                                !item.score ? (
                                    <span style={{display: 'inline-block', width: "5px", height: "5px", borderRadius: "50%", marginRight: '5px', background: "#fff", marginTop: '-2px'}}></span>
                                ) : (
                                    <span style={{display: 'inline-block', width: "5px", height: "5px", borderRadius: "50%", marginRight: '5px', marginTop: '-2px'}}></span>
                                )
                            ) : (null)
                        }
                        {item.active ? (
                            <span style={{fontSize: '1rem'}}>{item.content}</span>
                        ) : (item.content)}
                    </MenuItemContainer>
                ))}
            </MenuBarMenu>
        </div>
    );
};

const mapStateToProps = state => ({
    isRtl: state.locales.isRtl,
});
export default connect(mapStateToProps)(DropdownMenu);
